var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYoutubeTop(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 110.55 110.55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-youtube {\n        fill: none;\n        stroke: currentcolor;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 4.49px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_31",
    "data-name": "Grupo 31"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6",
    "data-name": "Rect\\xE1ngulo 6",
    className: "cls-youtube",
    x: 8.18,
    y: 24.56,
    width: 94.2,
    height: 61.43,
    rx: 18.43,
    ry: 18.43
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5",
    "data-name": "Trazado 5",
    className: "cls-youtube",
    d: "M69.61,55.26l-28.67,14.33v-28.64l28.67,14.31Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeTop);
export default __webpack_public_path__ + "static/media/youtube-top.20c7e5e97900b7c38dca0ac269f4db34.svg";
export { ForwardRef as ReactComponent };